import React from 'react';
import * as mobxReact from 'mobx-react';
import { useIntl } from 'react-intl';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import { TEXT_AREA_LABEL } from '../meeting-co-pilot.texts';
import { MeetingCoPilotVM } from '../meeting-co-pilot.viewmodal';
import './meeting-co-pilot-form.scss';

interface IProps {
    vm: MeetingCoPilotVM;
}

const MeetingCoPilotFormPresentation = mobxReact.observer((props: IProps) => {
    const { vm } = props;
    const intl = useIntl();

    /* [OEP-14168] - temporary hidden
    const field = {
        value: vm.getMeetingTemplateId(),
        setValue: (value: string) => vm.setMeetingTemplateId(value),
    };

    const customOptions = (): JSX.Element => {
        return (
            <>
                <option value={''}>{intl.formatMessage(NO_TEMPLATE_SELECTED_TEXT)}</option>
                {
                    vm.getTemplatesOptions().map(({ blueprintId, name }) => {
                        return <option value={blueprintId} key={blueprintId}>{name}</option>;
                    })
                }
            </>
        );
    };*/

    return (
        <form className='oe-form meeting-co-pilot-form'>
            <div className='oe-form_body'>
                <FormField
                    className='oe-form-field'
                    label={intl.formatMessage(TEXT_AREA_LABEL)}
                >
                    <textarea
                        className='oe-form-field__control meeting-co-pilot-form__textarea'
                        value={vm.getMeetingCoPilotText()}
                        onChange={e => vm.setMeetingCoPilotText(e.target.value)}
                    />
                    {vm.showValidationError() && <span className='oe-form-field__error'>{vm.getRequiredCoPilotMessageError()}</span>}
                    <span className='oe-form-field__error'>{vm.getTooLongCoPilotMessageError()}</span>
                </FormField>
                {/* [OEP-14168] - temporary hidden
                {formData.canApplyTemplateToMeeting()
                    && <FormFieldInput.Select
                        field={field}
                        labelDescriptor={MEETING_TEMPLATE_TEXT}
                        customOptions={customOptions()}
                        fieldClassName='oe-form-field meeting-co-pilot-form__template-selector'
                    />
                }*/}
            </div>
        </form>
    );
});

export { MeetingCoPilotFormPresentation };
